module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit","view":"View","addNew":"+ Add new classifier"},"et":{"edit":"Edit","view":"View","addNew":"+ Add new classifier"},"ru":{"edit":"Edit","view":"View","addNew":"+ Add new classifier"}}')
  delete Component.options._Ctor
}
